import React from 'react';
import { Link } from 'react-router-dom';

import { Col, Row } from 'react-bootstrap';
import { Card, Text, Button } from 'v3/components';

import * as Styled from './styles';

export function VehicleBodiesCard({ vehicleBody }) {
  return (
    <Col md={6} xs={12}>
      <Card
        header={
          <div>
            <Text>{vehicleBody?.plate}</Text>
          </div>
        }
        HeaderRightComponent={
          <div>
            <Link to={`/carrocerias/${vehicleBody.id}`}>
              <Button className="mr-2" variant="secondary">
                <Text color="dark" weight={500}>
                  Detalhes
                </Text>
              </Button>
            </Link>
          </div>
        }
      >
        <Row>
          <Col md={12}>
            <Text type="label" color="dark">
              Proprietário do documento
            </Text>
            <Text type="regular" color="gray" as="p" className="mt-2">
              {vehicleBody?.ownerWagon?.label || 'Não informado'}
            </Text>
          </Col>
          <Col md={12}>
            <Text type="label" color="dark">
              Tipo de carroceria
            </Text>
            <Text type="regular" color="gray" as="p" className="mt-2">
              {vehicleBody?.bodyType?.name || 'Não informado'}
            </Text>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}
